import React, { useEffect, useState } from "react";
import { Container, Card, Row, Col, Button } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { message } from "antd";
import { getDocs, collection } from "firebase/firestore/lite";
import { db } from "../firebase/firebase-config";

const FAQs = () => {
  const [faqs, setFaqs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchFAQs();
  }, []);

  async function fetchFAQs() {
    try {
      setIsLoading(true);
      const faqCollection = collection(db, "faqs");
      const faqSnapshot = await getDocs(faqCollection);
      const faqList = faqSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      console.log("This is faq list", faqList);
      setFaqs(faqList);
    } catch (err) {
      message.error("Error fetching FAQs: " + err.message);
    } finally {
      setIsLoading(false);
    }
  }

  const handleWhatsAppClick = () => {
    const phoneNumber = "078527878"; // Replace with your WhatsApp number
    const message = encodeURIComponent("Hello, I have a question regarding your services.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  // Split the FAQs into two halves
  const firstHalf = faqs.slice(0, 4);
  const secondHalf = faqs.slice(4, 8);

  return (
    <>
      <Navbar />
      <Container className="py-5 mt-5">
        {/* Main Card Wrapping Content */}
        <Card className="p-5 shadow-lg rounded-lg">
          <Card.Body>
            <h2 className="text-center mb-4">Frequently Asked Questions</h2>

            {isLoading ? (
              <div className="text-center">Loading FAQs...</div>
            ) : (
              <Row className="g-4">
                {/* Left Column for the first 4 questions */}
                <Col xs={12} md={6} className="mb-4">
                  <h3>Questions 1 to 4</h3>
                  {firstHalf.map((faqCategory, index) => (
                    <Card className="p-4 shadow-lg rounded-lg mb-4" key={index}>
                      <Card.Body>
                        <h4 className="font-semibold text-gray-800 mb-3">
                          <span className="text-primary">{index + 1}.</span> {faqCategory?.question}
                        </h4>
                        <p className="text-gray-600">{faqCategory?.answer}</p>
                      </Card.Body>
                    </Card>
                  ))}
                </Col>

                {/* Right Column for the next 4 questions */}
                <Col xs={12} md={6}>
                  
                  {secondHalf.map((faqCategory, index) => (
                    <Card className="p-4 shadow-lg rounded-lg mb-4" key={index}>
                      <Card.Body>
                        <h4 className="font-semibold text-gray-800 mb-3">
                          <span className="text-primary">{index + 5}.</span> {faqCategory?.question}
                        </h4>
                        <p className="text-gray-600">{faqCategory?.answer}</p>
                      </Card.Body>
                    </Card>
                  ))}
                </Col>
              </Row>
            )}

            {/* Ask Now Button */}
            <div className="text-center mt-5">
              <Button
                className="bg-green-500 text-white px-4 py-2 rounded-md text-lg shadow-md hover:bg-green-600 transition-all"
                onClick={handleWhatsAppClick}
              >
                📲 Ask Now
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <Footer />
    </>
  );
};

export default FAQs;
